module.exports = __webpack_public_path__ + "img/sos.a36ab46c.png";